import { REGEX } from '@/constants/regex';
import { ILottieComponentProps } from '@/types/common';
import { replaceColor } from 'lottie-colorify';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { useRef } from 'react';
import paySendAnimation from './lotties/PaySend.json';

export const PaySendLottie = ({ color = '' }: ILottieComponentProps) => {
  const isValidColor = new RegExp(REGEX.HEX_COLOR).test(color);
  const coloredPaySendAnimation = isValidColor
    ? replaceColor([147, 149, 152], color, paySendAnimation)
    : paySendAnimation;
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  const handleComplete = () => {
    lottieRef.current?.goToAndStop(500);
  };

  return (
    <Lottie
      lottieRef={lottieRef}
      style={{ height: '40px' }}
      animationData={coloredPaySendAnimation}
      loop={false}
      onComplete={handleComplete}
    />
  );
};
